import React__default from 'react';
import { __rest, __assign } from '../../_virtual/_tslib.js';
import { Avatar } from '@deal/components';
import classnames from 'classnames';
import styles from './styles.css.js';

/**
 * Displays a chat participants photo/avatar, or a consistently colored circle with their initials
 */

var ChatAvatar = function ChatAvatar(_a) {
  var _b;

  var sender = _a.sender,
      className = _a.className,
      shape = _a.shape,
      props = __rest(_a, ["sender", "className", "shape"]);

  return React__default.createElement(Avatar, __assign({
    name: sender.displayName,
    hash: sender.userId,
    src: sender.avatarUrl,
    className: classnames(className, (_b = {}, _b[styles.square] = shape === 'square', _b))
  }, props));
};

export default ChatAvatar;
//# sourceMappingURL=index.js.map
